"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusSynchXhrBlockRequestInformant = void 0;
const core_1 = require("../../core");
const types_1 = require("./types");
class EventBusSynchXhrBlockRequestInformant {
    constructor(xhrRequestsBlocker, eventBus) {
        this.eventBus = eventBus;
        this.xhrRequestsBlocker = xhrRequestsBlocker;
        this.eventBus.subscribe(types_1.TypeBlockRequestsEventMap.BLOCK_REQUESTS.toString(), () => {
            core_1.Log.info('[EventBusSynchXhrBlockRequestInformant]: Event BLOCK_REQUESTS received');
            this.xhrRequestsBlocker.startBlockingRequests();
        });
        this.eventBus.subscribe(types_1.TypeBlockRequestsEventMap.UNBLOCK_REQUESTS.toString(), () => {
            core_1.Log.info('[EventBusSynchXhrBlockRequestInformant]: Event UNBLOCK_REQUESTS received');
            this.xhrRequestsBlocker.finishBlockingRequest();
        });
    }
    startBlockingRequests() {
        this.eventBus.publish(types_1.TypeBlockRequestsEventMap.BLOCK_REQUESTS.toString(), new types_1.BlockRequestsEvent());
        core_1.Log.info('[EventBusSynchXhrBlockRequestInformant]: Event BLOCK_REQUESTS published');
    }
    finishBlockingRequest() {
        this.eventBus.publish(types_1.TypeBlockRequestsEventMap.UNBLOCK_REQUESTS.toString(), new types_1.UnblockRequestsEvent());
        core_1.Log.info('[EventBusSynchXhrBlockRequestInformant]: Event UNBLOCK_REQUESTS published');
    }
    isBlockingRequest() {
        throw Error('[EventBusSynchXhrBlockRequestInformant] Can not call isBlockingRequest');
    }
    getBlocker() {
        throw Error('[EventBusSynchXhrBlockRequestInformant] Can not call getBlocker');
    }
}
exports.EventBusSynchXhrBlockRequestInformant = EventBusSynchXhrBlockRequestInformant;
//# sourceMappingURL=eventBussynchXhrBlockRequestInformant.js.map